import { ToastContainer } from "react-toastify";
import { useData } from "../context/DataContext";
import styles from "./Dashboard.module.css";
import { MainContent } from "./MainContent";
import { Sidebar } from "./Sidebar";

export const DashboardLayout = () => {
  const { data, loading } = useData();

  return (
    <>
      <div className={styles.dashboard}>
        <div className={styles.dashboardContainer}>
          <Sidebar />
          <MainContent data={data} loading={loading} />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
